<template>
  <vx-card title="شبکه های اجتماعی">
    <vs-row class="mb-0">
      <vs-col
        class="mb-3"
        v-for="social in socials"
        :key="social.id"
        vs-xs="12"
        vs-sm="6"
        vs-lg="6"
      >
        <p>{{ social.label }}</p>
        <div class="input-container">
          <input v-model="social.url" class="w-full mt-1" />
          <p style="direction: ltr">
            {{ social.startAdornment }}
          </p>
        </div>
        <p
          v-if="social.type === 'instagram' || social.type === 'telegram'"
          style="font-size: 0.8rem; margin-top: 2px"
        >
          {{ "تنها ایدی لینک مورد نظر را وارد کنید." }}
        </p>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import { isEnglishDigits } from "../../../helpers/Functions";
import SocialsData from "./SocialsData.json";

export default {
  name: "Socials.vue",
  data() {
    let socials = [...SocialsData];
    socials.forEach((item, index) => {
      this.socialsData?.forEach((element) => {
        if (item.id === element.id) {
          socials[index] = { ...item, ...element };
        } else if (!element.id) {
          socials[0] = { ...socials[0], url: element.split("com/")[1] };
        }
      });
    });
    return { socials };
  },
  methods: {
    getSocialMedias() {
      for (const item of this.socials) {
        if (isEnglishDigits.test(item.url)) {
          this.$vs.notify({
            text: `${item.label} باید شامل لینک باشد.`,
            color: "danger",
            position: "bottom-center",
          });
          return false;
        }
      }

      return this.socials
        .filter((item) => item.url !== "")
        .map((item) => ({
          ...item,
          url: item.url?.replace(/^https?:\/\//, ""),
        }));
    },
  },
  props: {
    socialsData: {
      type: Array,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.input-container {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.5rem;

  input {
    margin-bottom: 4px;
    direction: rtl;
    text-align: right;
  }
}
</style>